import React, { useContext } from 'react';
import Toolbar from '@mui/material/Toolbar';
import logo from '../../assets/images/NewOrganDataLogo.svg';
import trustIcon from '../../assets/images/trust_icon.svg';
import unverifiedIcon from '../../assets/images/unverified_icon.svg';
import trustCheck from '../../assets/images/trustCheck.svg';
import { Link } from 'react-router-dom';
import { Avatar, Chip, Fab, Stack, Tooltip } from '@mui/material';
import Grid from '@mui/material/Grid';
import { useSelector } from 'react-redux';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import utils from '../../utils/utils';
import Popover from '@mui/material/Popover';
import Button from '@mui/material/Button';
import InsightSideAiIcon from '../../assets/images/Black&YellowAIIcon.svg';
import useMediaQuery from '@mui/material/useMediaQuery';
import { styled, useTheme, Theme, CSSObject } from '@mui/material/styles';
import Box from '@mui/material/Box';
import MuiDrawer from '@mui/material/Drawer';
import MuiAppBar, { AppBarProps as MuiAppBarProps } from '@mui/material/AppBar';
import List from '@mui/material/List';
import CssBaseline from '@mui/material/CssBaseline';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import PublicIcon from '@mui/icons-material/Public';
import SvgIcon from '@mui/material/SvgIcon';
import AssuredWorkloadIcon from '@mui/icons-material/AssuredWorkload';
import { JSX } from 'react/jsx-runtime';
import { AppContext } from '../../containers/AppProviderWrapper';
import { useNavigate } from 'react-router-dom';

const drawerWidth = 180;

const openedMixin = (theme: Theme): CSSObject => ({
    width: drawerWidth,
    transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
    }),
    overflowX: 'hidden',
});

const closedMixin = (theme: Theme): CSSObject => ({
    transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: 'hidden',
    width: `calc(${theme.spacing(7)} + 1px)`,
    [theme.breakpoints.up('sm')]: {
        width: `calc(${theme.spacing(8)} + 1px)`,
    },
});

const AppBar = styled(MuiAppBar, {
    shouldForwardProp: (prop) => prop !== 'open',
})<MuiAppBarProps>(({ theme }) => ({
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
    }),
    variants: [
        {
            // @ts-ignore
            props: ({ open }) => open,
            style: {
                marginLeft: drawerWidth,
                width: `calc(100% - ${drawerWidth}px)`,
                transition: theme.transitions.create(['width', 'margin'], {
                    easing: theme.transitions.easing.sharp,
                    duration: theme.transitions.duration.enteringScreen,
                }),
            },
        },
    ],
}));

const DrawerHeader = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
}));

const Drawer = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== 'open' })(({ theme }) => ({
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: 'nowrap',
    boxSizing: 'border-box',
    variants: [
        {
            props: ({ open }) => open,
            style: {
                ...openedMixin(theme),
                '& .MuiDrawer-paper': openedMixin(theme),
            },
        },
        {
            props: ({ open }) => !open,
            style: {
                ...closedMixin(theme),
                '& .MuiDrawer-paper': closedMixin(theme),
            },
        },
    ],
}));
// @ts-ignore
const Navbar = ({ dashboardView, children }) => {
    const { selectedDashboard, setSelectedDashboard } = useContext(AppContext);
    const dashboard = useSelector((state: any) => state.dashboard);
    const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null);
    const [openDrawer, setOpenDrawer] = React.useState(false);
    const open = Boolean(anchorEl);
    const theme = useTheme();
    const matches = useMediaQuery(theme.breakpoints.down('md'));
    const navigate = useNavigate();

    const sidebarItems = [
        {
            title: 'Overview',
            icon: <PublicIcon />,
            link: '/overview',
        },
        // {
        //     title: 'Kidney',
        //     icon: (
        //         <svg
        //             fill="#E8C658"
        //             height="200px"
        //             width="200px"
        //             version="1.1"
        //             id="Layer_1"
        //             xmlns="http://www.w3.org/2000/svg"
        //             viewBox="0 0 499.998 499.998"
        //             stroke="#E8C658"
        //         >
        //             <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
        //             <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
        //             <g id="SVGRepo_iconCarrier">
        //                 {' '}
        //                 <g>
        //                     {' '}
        //                     <g>
        //                         {' '}
        //                         <path d="M473.897,334.142c-1.636-1.856-39.948-35.38-54.724-45.64c-20.828-18.236-38.652-36.928-53.468-56.032 c-0.04-0.16-0.024-0.324-0.084-0.48c-7.048-17.8-1.292-48.632,4.792-81.28c8.82-47.288,18.816-100.888-8.508-129.772 c-17.44-18.424-47.372-24.604-91.492-18.876C129.377,20.354,26.885,174.922,19.649,307.818 c-5.32,97.484,38.772,164.82,120.964,184.752c20.444,4.956,39.544,7.432,57.26,7.428c34.584,0,63.896-9.432,87.512-28.24 c53.58-42.66,61.76-119.908,62.984-145.868c18.248,2.22,36.564,9.012,54.632,20.444c9.072,5.736,26.64,20.964,30.212,24.22 c5.184,5.624,12.512,8.576,20.18,8.576h0.004c6.688,0,13.132-2.168,18.136-6.6c5.48-4.848,8.748-11.4,9.196-18.708 C481.173,346.522,478.749,339.618,473.897,334.142z M465.109,352.878c-0.2,3.124-1.6,5.848-3.948,7.924 c-2.144,1.908-4.908,2.676-7.764,2.676h-0.004c-3.348,0-6.552-1.152-8.868-3.756c-0.576-0.612-21.604-19.448-33.156-26.752 c-24.908-15.756-50.472-23.676-75.984-23.676c-1.728,0-3.476,0.076-5.236,0.148c-47.708,2.092-93.796,32.436-137,90.14 c-2.24,2.988-5.672,4.716-9.416,4.716c-2.544,0-4.976-0.804-7.016-2.332c-5.18-3.884-6.244-11.252-2.368-16.436 c37.58-50.192,78.224-81.776,120.796-93.892c3.476-0.988,5.82-4.232,5.676-7.836c-0.136-3.612-2.736-6.652-6.28-7.364 c-17.304-3.468-35.236-5.228-53.28-5.228c-36.928,0-75.656,7.344-115.092,21.828c-5.976,2.204-12.9-1.076-15.072-6.972 c-1.08-2.94-0.948-6.132,0.368-8.976c1.316-2.848,3.668-5.008,6.612-6.088c48.664-17.88,96.444-25.508,141.852-22.604 c3.596,0.248,6.9-2.036,7.968-5.488c1.072-3.448-0.36-7.188-3.452-9.04c-30.932-18.488-62.856-36.304-94.912-52.952 c-5.74-2.984-7.988-10.084-5.004-15.832c2.024-3.904,6.032-6.332,10.44-6.332c1.88,0,3.696,0.448,5.388,1.324 c39.492,20.512,78.544,42.64,116.08,65.756c3.044,1.872,6.964,1.444,9.532-1.024c2.568-2.468,3.148-6.372,1.4-9.476 c-24.352-43.26-36.104-88.732-34.94-135.132c0.16-6.416,5.396-11.44,12.028-11.44c3.132,0.08,6.048,1.372,8.212,3.644 c2.16,2.268,3.308,5.248,3.232,8.384c-1.956,78.42,36.176,152.372,113.316,219.792c0.228,0.2,0.472,0.384,0.724,0.56 c13.78,9.46,49.024,40.424,52.424,43.584C464.317,347.042,465.297,349.838,465.109,352.878z"></path>{' '}
        //                     </g>{' '}
        //                 </g>{' '}
        //             </g>
        //         </svg>
        //     ),
        //     link: '/kidney',
        // },
        // {
        //     title: 'Liver',
        //     icon: (
        //         <svg version="1.1" id="Icons" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" fill="#E8C658">
        //             <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
        //             <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
        //             <g id="SVGRepo_iconCarrier">
        //                 <g>
        //                     {' '}
        //                     <path d="M17,8V3c0-0.4-0.3-0.8-0.7-0.9l-3-1C13,0.9,12.7,1,12.4,1.2S12,1.7,12,2v6h-0.3C6.3,8,2,12.3,2,17.7v9c0,0.8,0.3,1.5,0.9,2 c0.4,0.3,0.9,0.4,1.4,0.4c0.4,0,0.7-0.1,1.1-0.3l7.4-4c0.9-0.5,1.8-0.9,2.7-1.2c2.1-4.4,2.9-9.9,2.2-14.9C17.6,8.4,17.3,8.1,17,8z"></path>
        //                     <path d="M29.4,8.7C29,8.3,28.5,8,27.9,8H25V4c0-0.3-0.2-0.6-0.4-0.8C24.3,3,24,2.9,23.7,3.1l-3,1C20.3,4.2,20,4.6,20,5v3.2 c-0.2,0.2-0.3,0.5-0.3,0.8c0.6,4.6,0,9.7-1.7,13.9c0.7-0.2,1.5-0.3,2.2-0.4c3.4-0.4,6.2-2.6,7.3-5.8l2.1-6.4 C29.8,9.8,29.7,9.2,29.4,8.7z"></path>
        //                     <path d="M13.7,26.6l-4.9,2.7c0.6,0.3,1.4,0.5,2.2,0.5c0.8,0,1.7-0.2,2.6-0.6c1.8-0.8,2.9-2.3,3.2-3.9l-0.5,0.2 C15.2,25.9,14.4,26.3,13.7,26.6z"></path>{' '}
        //                 </g>{' '}
        //             </g>
        //         </svg>
        //     ),
        //     link: '/liver',
        // },
        {
            title: 'Grants',
            icon: <AssuredWorkloadIcon />,
            link: '/grants',
        },
    ];

    const handleDrawerOpen = () => {
        setOpenDrawer(true);
    };

    const handleDrawerClose = () => {
        setOpenDrawer(false);
    };

    const handlePopoverOpen = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handlePopoverClose = () => {
        setAnchorEl(null);
    };

    const handleNavClick = (item: { title: any; icon?: JSX.Element; link?: string }) => {
        if (setSelectedDashboard) {
            setSelectedDashboard(item.title);
            navigate(`/dashboard/${item.title.toLowerCase()}`);
        }
    };

    const successTooltip = () => {
        return (
            <Grid container alignItems={'center'}>
                <Grid item xs={12}>
                    <Grid container alignItems={'center'}>
                        <Grid item xs={1}>
                            <img src={trustCheck} alt="" />
                        </Grid>
                        <Grid item>
                            <Typography variant={'body2'}>Cryptographic Signature Validated</Typography>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={12}>
                    <Grid container alignItems={'center'}>
                        <Grid item xs={1}>
                            <img src={trustCheck} alt="" />
                        </Grid>
                        <Grid item>
                            <Typography variant={'body2'}>Network Validation Verified</Typography>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={12}>
                    <Grid container alignItems={'center'}>
                        <Grid item xs={1}>
                            <img src={trustCheck} alt="" />
                        </Grid>
                        <Grid item>
                            <Typography variant={'body2'}>Proof of Authenticity Passed</Typography>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        );
    };

    return (
        <Box sx={{ display: dashboardView && 'flex' }}>
            <CssBaseline />
            <AppBar
                position={dashboardView ? 'fixed' : 'static'}
                elevation={0}
                sx={{ backgroundColor: '#0b0b0b !important' }}
                // @ts-ignore
                open={openDrawer}
            >
                <Toolbar>
                    <Grid container justifyContent={matches ? 'center' : 'space-between'} alignItems={'flex-end'}>
                        <Grid item style={{ marginTop: matches ? 20 : 10 }}>
                            {dashboardView && (
                                <IconButton
                                    color="inherit"
                                    aria-label="open drawer"
                                    onClick={handleDrawerOpen}
                                    edge="start"
                                    sx={[
                                        {
                                            marginRight: 5,
                                            color: '#E8C658',
                                        },
                                        openDrawer && { display: 'none' },
                                    ]}
                                >
                                    <MenuIcon />
                                </IconButton>
                            )}
                            <Link to={'/'} style={{ textDecoration: 'none' }}>
                                <img src={logo} alt="" height={matches ? 55 : 40} style={{ maxWidth: '100%' }} />
                            </Link>
                        </Grid>
                        {dashboardView && (
                            <Grid item>
                                <Stack direction={matches ? 'column' : 'row'} spacing={1} alignItems={'center'}>
                                    <Chip
                                        icon={<AccessTimeIcon style={{ color: '#fff' }} />}
                                        label={
                                            dashboard && dashboard.timestamp
                                                ? `Data as of ${utils.formatDate(dashboard.timestamp)}`
                                                : '---'
                                        }
                                        variant="filled"
                                        style={{ color: '#fff', fontWeight: 'bold', backgroundColor: 'transparent' }}
                                    />
                                    {dashboard && dashboard.hederaTransaction ? (
                                        <a
                                            href={`https://hashscan.io/mainnet/transaction/${dashboard.hederaTransaction}`}
                                            target={'_blank'}
                                            rel="noreferrer"
                                            style={{ textDecoration: 'none' }}
                                        >
                                            <Chip
                                                avatar={
                                                    <Avatar alt="Verified" src={trustIcon} style={{ padding: 1 }} />
                                                }
                                                label="Validated Proof of Authenticity"
                                                variant="filled"
                                                style={{ color: '#fff', fontWeight: 'bold', padding: 5 }}
                                                aria-owns={open ? 'mouse-over-popover' : undefined}
                                                aria-haspopup="true"
                                                onMouseEnter={handlePopoverOpen}
                                                onMouseLeave={handlePopoverClose}
                                            />
                                        </a>
                                    ) : (
                                        <Chip
                                            avatar={<Avatar alt="Unverified" src={unverifiedIcon} />}
                                            label="---"
                                            variant="filled"
                                            style={{ color: '#fff', fontWeight: 'bold' }}
                                        />
                                    )}
                                    <Tooltip title={'Acoer AI Companion'}>
                                        <Link to={'/ai-companion'} style={{ textDecoration: 'none' }}>
                                            <Fab
                                                size="small"
                                                color="inherit"
                                                aria-label="AI Companion"
                                                sx={{
                                                    backgroundColor: '#fff',
                                                }}
                                            >
                                                <img src={InsightSideAiIcon} alt="" height={'100%'} />
                                            </Fab>
                                        </Link>
                                    </Tooltip>
                                </Stack>
                            </Grid>
                        )}
                    </Grid>
                </Toolbar>
                <Popover
                    id="mouse-over-popover"
                    sx={{
                        pointerEvents: 'none',
                    }}
                    open={open}
                    anchorEl={anchorEl}
                    anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'center',
                    }}
                    transformOrigin={{
                        vertical: 'bottom',
                        horizontal: 'center',
                    }}
                    onClose={handlePopoverClose}
                    disableRestoreFocus
                    PaperProps={{
                        style: {
                            borderRadius: 25,
                            border: 'solid #C8C8CC',
                            padding: 10,
                            maxWidth: 322,
                            marginTop: 40,
                        },
                    }}
                >
                    {successTooltip()}
                </Popover>
            </AppBar>
            {dashboardView && (
                <Drawer
                    variant="permanent"
                    open={openDrawer}
                    PaperProps={{
                        sx: {
                            backgroundColor: '#0b0b0b !important',
                            color: '#E8C658',
                            borderRadius: 0,
                        },
                    }}
                >
                    <DrawerHeader>
                        <IconButton onClick={handleDrawerClose}>
                            {theme.direction === 'rtl' ? (
                                <ChevronRightIcon sx={{ color: '#E8C658' }} />
                            ) : (
                                <ChevronLeftIcon sx={{ color: '#E8C658' }} />
                            )}
                        </IconButton>
                    </DrawerHeader>
                    <List style={{ marginTop: 2 }}>
                        {sidebarItems.map((item, index) => (
                            <ListItem
                                key={item.title}
                                disablePadding
                                sx={{
                                    display: 'block',
                                    backgroundColor:
                                        selectedDashboard?.toLowerCase() === item.title.toLowerCase()
                                            ? '#696969'
                                            : '#0b0b0b',
                                }}
                                onClick={() => handleNavClick(item)}
                            >
                                <ListItemButton
                                    sx={[
                                        {
                                            minHeight: 48,
                                            px: 2.5,
                                        },
                                        openDrawer
                                            ? {
                                                  justifyContent: 'initial',
                                              }
                                            : {
                                                  justifyContent: 'center',
                                              },
                                    ]}
                                >
                                    <ListItemIcon
                                        sx={[
                                            {
                                                minWidth: 0,
                                                justifyContent: 'center',
                                                color: '#E8C658',
                                            },
                                            openDrawer
                                                ? {
                                                      mr: 3,
                                                  }
                                                : {
                                                      mr: 'auto',
                                                  },
                                        ]}
                                    >
                                        <SvgIcon>{item.icon}</SvgIcon>
                                    </ListItemIcon>
                                    <ListItemText
                                        primary={item.title}
                                        sx={[
                                            {
                                                color: '#E8C658',
                                                fontWeight: 'bold',
                                            },
                                            openDrawer
                                                ? {
                                                      opacity: 1,
                                                  }
                                                : {
                                                      opacity: 0,
                                                  },
                                        ]}
                                    />
                                </ListItemButton>
                            </ListItem>
                        ))}
                    </List>
                </Drawer>
            )}
            {!dashboardView && (
                <Grid container alignItems={'center'} style={{ verticalAlign: 'center', minHeight: 300 }}>
                    <Grid item xs={1}></Grid>
                    <Grid item xs={10} md={6}>
                        <Grid container direction={'column'} spacing={2} sx={{ mt: 2 }}>
                            <Grid item>
                                <Typography color={'#fff'} variant={'h1'} sx={{ fontWeight: 'bold', fontSize: 36 }}>
                                    Explore Latest
                                </Typography>
                                <Typography color={'#fff'} variant={'h1'} sx={{ fontWeight: 'bold', fontSize: 36 }}>
                                    Organ Procurement Data
                                </Typography>
                            </Grid>
                            <Grid item>
                                <Typography color={'#fff'} variant={'body1'}>
                                    The Organ Procurement Explorer is a dynamic tool that provides the latest data and
                                    insights into organ donation and transplantation trends. Designed to make complex
                                    data accessible, it allows users to explore statistics on donor demographics,
                                    waitlist dynamics, transplant rates, and performance across organ procurement
                                    organizations (OPOs).
                                </Typography>
                            </Grid>
                            <Grid item>
                                <Link to={`/dashboard/overview`} style={{ textDecoration: 'none', paddingRight: 10 }}>
                                    <Button
                                        variant={'contained'}
                                        style={{
                                            fontWeight: 'bold',
                                            borderRadius: 30,
                                        }}
                                    >
                                        Discover Now
                                    </Button>
                                </Link>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            )}
            <Box component="main" sx={{ flexGrow: 1, p: 3, mt: 5 }}>
                <Grid container>{children}</Grid>
            </Box>
        </Box>
    );
};

export default Navbar;
